<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="selectedUrl ? `${addurl}/${inputs.id}` : addurl"
      >
      <div class="row">
        <div class="col-md-6">
            <label for="text_input">
              {{ $t("staff_role") }}
            </label>
            <app-input
              id="staff_role"
              type="search-select"
              :list="roleLists"
              list-value-field="name"
              :isAnimatedDropdown="true"
              v-model="inputs.staff_role"
              :required="true"
            />
          </div>
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("staff_count") }}
            </label>
            <app-input
              id="staff_count"
              type="number"
              v-model="inputs.staff_count"
              :required="true"
            />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <label for="text_input">
              {{ $t("office_branch") }}
            </label>
            <app-input
              id="office_branch"
              type="search-select"
              :list="branchList"
              :isAnimatedDropdown="true"
              v-model="inputs.office_branch_id"
              :required="true"
            />
          </div>
        </div>    
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import * as actions from "../../../../../Config/ApiUrl";
import { axiosPost} from "../../../../../../app/Helpers/AxiosHelper";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    companyId: Number,
  },
  data() {
    return {
      addurl:actions.COMPANY_HEADCOUNT_STORE,
      preloader: false,
      roleLists: [],
      branchList: [],
      inputs: {
        company_id: this.companyId,
      },
      statusLists: [
        { id: "no", value: "No" },
        { id: "yes", value: "Yes" },
      ],
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
    }
  },
  methods: {
    submit() {
      if (this.modalTitle == "Edit") {
        this.preloader = true;
        axiosPost(actions.COMPANY_HEADCOUNT_UPDATE, this.inputs)
          .then((res) => {
            
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#demo-add-edit-Modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      } else {
      this.save(this.inputs);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
    getRoles() {
      this.preloader = this.hasData ? true : false;

      this.axiosGet(actions.ROLES)
        .then((response) => {
          this.roleLists = response.data.data;
        })
        .catch(({ response }) => {})
        .finally(() => {
          this.preloader = false;
        });
    },
    getOfficeBrances() {
      this.preloader = this.hasData ? true : false;

      this.axiosGet(actions.OFFICE_BRANCHES_GET+this.companyId)
        .then((response) => {
          this.branchList = response.data;
        })
        .catch(({ response }) => {})
        .finally(() => {
          this.preloader = false;
        });
    }
  },

  mounted() {
    // $(function () {
    //   $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    // });
    this.getRoles();
    this.getOfficeBrances();
  },
};
</script>
